// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.sustainable-component .title[data-v-0273f0f9] {\n        color: black;\n        background-color: white;\n        position: absolute;\n        top: -18px;\n        left: 14px;\n        width: -moz-fit-content;\n        width: fit-content;\n        font-size: 12px;\n        font-weight: 400\n}\n\n    \n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
